import { SkeletonTypes, UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Typography } from '@genial/design-tokens';
import React from 'react';

export const ColoredSkeleton = (props: SkeletonTypes.Props) => (
  <UI.Skeleton
    height={Typography['fontsize.lg']}
    borderRadius={BoxRadius.sm}
    endColor="brand.primary.lightest"
    {...props}
  />
);

export const SkeletonItemMobile: React.FC = () => {
  return (
    <VStack px="inline.xxxs" py="stack.xxxs" space="stack.xxs">
      <VStack space="inline.xxxs" w="full" p="inline.xxxs">
        <VStack space="inline.sm">
          <HStack space="inline.quarck">
            <UI.Heading testId="offer-summary-header" size="h3" color="brand.primary.principal">
              Ordem
            </UI.Heading>
            <ColoredSkeleton width="80px" />
          </HStack>

          <VStack space="stack.quarck">
            <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
              Valor da operação
            </UI.Text>
            <ColoredSkeleton height={Typography['fontsize.xl']} width="120px" />
          </VStack>
        </VStack>

        {Array.from({ length: 4 }, (_, i) => i).map((item) => (
          <HStack key={item.toString()} justifyContent="space-between" w="full">
            <ColoredSkeleton width="60%" />
            <ColoredSkeleton width="20%" />
          </HStack>
        ))}
      </VStack>

      {Array.from({ length: 2 }, (_, i) => i).map((item) => (
        <HStack key={item.toString()} w="full">
          <ColoredSkeleton height={item === 0 ? '350px' : 'inline.md'} width="full" />
        </HStack>
      ))}
    </VStack>
  );
};
